
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';
import { Team } from '../types';

export function useTeamsList() {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['teams'],
    queryFn: async () => {
      if (!user) throw new Error('User not authenticated');
      
      // Get teams where user is a member using team_members table
      const { data: memberships, error: membershipError } = await supabase
        .from('team_members')
        .select('team_id')
        .eq('user_id', user.id);
        
      if (membershipError) throw membershipError;
      
      if (!memberships || memberships.length === 0) {
        return [] as Team[];
      }
      
      // Get the actual team details using the team_ids
      const teamIds = memberships.map(membership => membership.team_id);
      
      const { data, error } = await supabase
        .from('teams')
        .select('*')
        .in('id', teamIds)
        .order('created_at', { ascending: false });

      if (error) throw error;
      
      return data as Team[];
    },
    enabled: !!user
  });
}
